module.exports = __webpack_public_path__ + "img/homepage-custom.6cdd9f4.jpg";